import { useBraze } from '@components/Braze';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getSummary } from '@/pages/CompanyReport/redux/selectors/getCompanySummary';

export const BrazeLogCompanyViewed = ({ companyId }: { companyId: string }) => {
  const { logCustomEvent } = useBraze();
  const logged = useRef(false);
  const summary = useSelector((state) => getSummary(state, { companyId }));

  useEffect(() => {
    if (logged.current) {
      return;
    }
    if (typeof summary === 'undefined') {
      return;
    }
    logged.current = true;
    logCustomEvent('company_viewed', {
      companyIndustry: summary.industryData.primaryName,
      companyMarket: summary.exchangeSymbol,
      companyName: summary.name,
      companyTicker: summary.tickerSymbol,
    });
  }, [summary]);

  return null;
};
